export default (data) => ({
  __typename: data.__typename,
  text: data?.html?.json ?? '',
})
